// 对应原型 data-city.js 的六类城市部件；存储仍使用原有 icon 字符，不改版本/评分数据。
export const MAP_PART_SYMBOLS = Object.freeze([
  { key: 'cover', name: '井盖', icon: '⬤' },
  { key: 'fire', name: '消防设施', icon: '⛑' },
  { key: 'bridge', name: '过街天桥', icon: '⌒' },
  { key: 'sign', name: '交通标志牌', icon: '◇' },
  { key: 'park', name: '停车场', icon: '▣' },
  { key: 'trash', name: '垃圾间', icon: '⌂' }
].map(symbol => Object.freeze(symbol)))

export function mapPartGlyph (icon) { return String(icon || '●') }

export function mapPartSymbolOptions (icon) {
  const value = icon == null ? '' : String(icon)
  const options = MAP_PART_SYMBOLS.map(symbol => ({ value: symbol.icon, label: symbol.icon + ' ' + symbol.name }))
  // 旧图元只作为当前值兼容保留，不增加自由输入，也不在载入时自动替换历史数据。
  if (!options.some(option => option.value === value)) {
    const label = value ? value.slice(0, 24) + (value.length > 24 ? '…' : '') + '（原有图元，保留）' : '● 默认圆点（原有未设置）'
    options.unshift({ value, label, legacy: true })
  }
  return options
}
